import React from "react";
import { Crown } from "lucide-react";

export const ProBadge: React.FC<{ className?: string; label?: string }> = ({
  className = "",
  label = "Pro",
}) => (
  <span
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold
      bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-sm ${className}`}
  >
    <Crown size={10} />
    {label}
  </span>
);

export const FreeBadge: React.FC<{ className?: string; label?: string }> = ({
  className = "",
  label = "Free",
}) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium
      bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300 ${className}`}
  >
    {label}
  </span>
);

/**
 * 無料開放バッジ。2026年度は全機能を無料で開放しているが、これは有料プラン加入では
 * ないため Pro バッジを出さない（課金していない利用者に有料プラン表示を出さない）。
 * 2027年の Pro 有料化時に、加入者だけ ProBadge へ置き換わる。
 */
export const FreeOpenBadge: React.FC<{ className?: string; label?: string }> = ({
  className = "",
  label = "無料公開中",
}) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold
      bg-slate-100 text-slate-600 border border-slate-200
      dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600 ${className}`}
  >
    {label}
  </span>
);
